import FixtureCardFirstSlot from './fixtureCardFirstSlot.component';

export * from './fixtureCardFirstSlot.types';
export default FixtureCardFirstSlot;
